import * as React from 'react'
import { ChevronDown } from 'lucide-react'
import { cn } from '@/lib/utils'

/*
 * Native select — the contract's default for ten options or fewer.
 * Above ten options a searchable combobox is mandated instead.
 */
function NativeSelect({
  className,
  children,
  ...props
}: React.SelectHTMLAttributes<HTMLSelectElement>) {
  return (
    <div className="relative">
      <select
        data-slot="native-select"
        className={cn(
          'h-10 w-full appearance-none rounded-sm border border-line-strong bg-surface pl-3 pr-9 text-sm text-fg',
          'transition-colors hover:border-line-strong',
          'disabled:cursor-not-allowed disabled:opacity-60',
          'aria-[invalid=true]:border-danger',
          className,
        )}
        {...props}
      >
        {children}
      </select>
      <ChevronDown
        aria-hidden="true"
        className="pointer-events-none absolute right-2.5 top-1/2 size-4 -translate-y-1/2 text-fg-muted"
      />
    </div>
  )
}

export { NativeSelect }
